var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.qty || _vm.white,
          expression: "qty || white"
        }
      ],
      staticClass: "relative",
      class: _vm.white ? "inline align-middle" : null
    },
    [
      _c(
        "svg",
        {
          staticClass: "cursor-pointer",
          class: _vm.white ? "inline" : null,
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "22",
            height: "18",
            viewBox: "0 0 22 18",
            tabindex: _vm.white ? null : 0
          },
          on: {
            click: function($event) {
              return _vm.$emit("click", $event)
            }
          }
        },
        [
          _c("path", {
            staticClass: "fill-current",
            class: _vm.white ? "text-white" : "text-brand",
            attrs: {
              d:
                "M21.854 2.863a.827.827 0 0 0-.685-.368H6.74L4.868.375A1.098 1.098 0 0 0         4.044 0H1.108C.496 0 0 .506 0 1.13c0 .623.496 1.129 1.108 1.129H3.55l1.51 1.712         3.202 8.486a.831.831 0 0 0 .775.543h8.808a.831.831 0 0 0 .775-.543l3.324-8.81a.861.861 0 0 0-.09-.784z"
            }
          }),
          _c("path", {
            staticClass: "fill-current",
            class: _vm.white ? "text-white" : "text-brand",
            attrs: { d: "M10 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" }
          }),
          _c("path", {
            staticClass: "fill-current",
            class: _vm.white ? "text-white" : "text-brand",
            attrs: { d: "M17 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" }
          })
        ]
      ),
      _vm.qty
        ? _c(
            "div",
            {
              staticClass:
                "qty absolute text-brand bg-white border border-brand text-center"
            },
            [_vm._v(_vm._s(_vm.qty))]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }